module.exports = __webpack_public_path__ + "assets/img/store.bb88cad4.svg";